import React, { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, Form, Alert } from 'reactstrap';
import axios from 'axios'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'
import { useEffect } from 'react';

const UpdateLandingPhoto = props => {
    const [errorMessage, setErrorMessage] = useState('')
    const [profilePic, setProfilePic] = useState('')
    const [loading, setLoading] = useState(false)
    const photoURI = 'https://script.google.com/macros/s/AKfycbwJC4RaNmZxxct9g7vb5-H1i_5fxo22sUi6dBOv3I0eSMqqDpU3/exec'


    const profilePicChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 2097152 || file.type.substr(0, 5) !== 'image') {
                setErrorMessage('Requires Image File below 2mb')
            } else {
                setProfilePic(file)
            }
        }
    };

    const submitProfile = e => {
        e.preventDefault();
        setErrorMessage('')
        var reader = new FileReader();
        setLoading(true)

        reader.readAsDataURL(profilePic);
        reader.onloadend = async e => {
            const image = {
                photo: e.target.result,
                key: 'nnnlwe19219n1b2--u0qjasca'
            }
            await axios.post(photoURI, JSON.stringify(image))
                .then(async res => {
                    const newPhoto = {
                        landingPage: res.data,
                    }
                    if (props.adminDetails) {
                        await axios.patch('/api/site-admin/' + props.adminDetails._id, newPhoto, tokenConfig())
                            .then(res => {
                                setLoading(false)
                                setProfilePic('')
                                props.toggle()
                                props.loadImages()
                            })
                            .catch(err => {
                                setLoading(false)
                                setErrorMessage(err.response.data.message)
                            })
                    } else {
                        await axios.post('/api/site-admin', newPhoto, tokenConfig())
                            .then(res => {
                                setLoading(false)
                                setProfilePic('')
                                props.toggle()
                                props.loadImages()
                            })
                            .catch(err => {
                                setLoading(false)
                                setErrorMessage(err.response.data.message)
                            })
                    }

                })
                .catch(err => {
                    setLoading(false)
                    setErrorMessage(err.response.data.message)
                })
        };
    };

    return (
        // console.log(this.state.editor),
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Profile Photo</ModalHeader>

                <ModalBody>
                    {errorMessage ? <Alert color='danger'>{errorMessage}</Alert> : null}

                    <input
                        type='file'
                        name='profilePicBtn'
                        accept='image/*'
                        onChange={profilePicChange}
                    />
                    <Button
                        color='dark'
                        style={{ marginTop: '2rem', cursor: loading && 'progress' }}
                        block
                        disabled={loading ? true : !profilePic}
                        onClick={(e) => submitProfile(e)}
                    >
                        Upload Photo
                    </Button>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default UpdateLandingPhoto